/**
 * Saves a Blob under a caller-chosen filename. The one place that touches the DOM for a
 * download, so the object URL is always revoked and callers never build the link themselves.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
